import { render, staticRenderFns } from "./MotionWindow.vue?vue&type=template&id=5dd8a4f1&scoped=true&"
import script from "./MotionWindow.vue?vue&type=script&lang=js&"
export * from "./MotionWindow.vue?vue&type=script&lang=js&"
import style0 from "./MotionWindow.vue?vue&type=style&index=0&id=5dd8a4f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd8a4f1",
  null
  
)

component.options.__file = "MotionWindow.vue"
export default component.exports